let isLoading = false;
let isRestoringListing = false;
let activeObservers = [];

const getUrlWithoutPhcursor = (value, pageValue) => {
  const url = new URL(value, window.location.origin);
  url.searchParams.set('page', pageValue);
  url.searchParams.delete('phcursor');
  return url.pathname + '?' + url.searchParams.toString();
};

const getPaginationInputs = () => ({
  totalPages: parseInt(document.querySelector('[data-total-pages]')?.value, 10),
  currentPage: parseInt(document.querySelector('[data-current-page]')?.value, 10),
  nextUrlRaw: document.querySelector('[data-next-url]')?.value,
});

const appendLoadedPage = (responseHTML) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(responseHTML, 'text/html');
  const newItems = doc.querySelector('.load-more-grid');
  const grid = document.querySelector('.load-more-grid');
  if (!newItems || !grid) return false;

  grid.insertAdjacentHTML('beforeend', newItems.innerHTML);
  if (typeof colorSwatches === 'function') colorSwatches(grid);
  if (window.InlineCart?.init) window.InlineCart.init(grid);
  return true;
};

const updatePaginationState = (currentPage, totalPages, nextUrlScroll) => {
  document.querySelectorAll('[data-current-page]').forEach((el) => {
    el.value = String(currentPage);
    el.dataset.currentPage = String(currentPage);
  });

  if (currentPage !== totalPages) {
    document.querySelectorAll('[data-next-url]').forEach((el) => {
      el.value = nextUrlScroll;
      el.dataset.nextUrl = nextUrlScroll;
    });
  }

  const scrollData = document.querySelector('.infinite-scroll__data');
  if (scrollData && currentPage !== totalPages) {
    const nextUrlInput = scrollData.querySelector('input[data-next-url]');
    const currentPageInput = scrollData.querySelector('input[data-current-page]');
    if (nextUrlInput) {
      nextUrlInput.dataset.nextUrl = nextUrlScroll;
      nextUrlInput.value = nextUrlScroll;
    }
    if (currentPageInput) {
      currentPageInput.dataset.currentPage = String(currentPage);
      currentPageInput.value = String(currentPage);
    }
    checkVisibility();
  }

  if (currentPage === totalPages) {
    document.querySelectorAll('.js-load-more').forEach((button) => button.remove());
  }
};

const waitForLoadMoreIdle = () =>
  new Promise((resolve) => {
    const check = () => {
      if (!isLoading) {
        resolve();
        return;
      }
      setTimeout(check, 30);
    };
    check();
  });

const loadNextPage = async (options = {}) => {
  const fast = Boolean(options.fast);
  await waitForLoadMoreIdle();
  if (isLoading) return false;

  const { totalPages, currentPage, nextUrlRaw } = getPaginationInputs();
  if (!nextUrlRaw || !Number.isFinite(totalPages) || !Number.isFinite(currentPage)) return false;
  if (currentPage >= totalPages) return false;

  isLoading = true;
  const nextPage = currentPage + 1;
  const nextUrl = getUrlWithoutPhcursor(nextUrlRaw, nextPage);
  const nextUrlScroll = getUrlWithoutPhcursor(nextUrlRaw, nextPage + 1);

  try {
    const response = await fetch(nextUrl);
    const responseHTML = await response.text();
    const appended = appendLoadedPage(responseHTML);
    if (!appended) return false;

    updatePaginationState(nextPage, totalPages, nextUrlScroll);
    return true;
  } catch (e) {
    console.error('LoadMore: failed to fetch next page', e);
    return false;
  } finally {
    const releaseDelay = fast || isRestoringListing ? 0 : 200;
    if (releaseDelay === 0) {
      isLoading = false;
    } else {
      setTimeout(() => {
        isLoading = false;
      }, releaseDelay);
    }
  }
};

const loadItems = async (button) => {
  if (isLoading || isRestoringListing) return;

  button?.setAttribute('disabled', '');
  button?.classList.add('loading');

  try {
    await loadNextPage();
  } finally {
    button?.removeAttribute('disabled');
    button?.classList.remove('loading');
  }
};

const checkVisibility = () => {
  if (isRestoringListing) return;

  activeObservers.forEach((obs) => obs.disconnect());
  activeObservers = [];

  document.querySelectorAll('.js-infinite-scroll').forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isRestoringListing) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
    activeObservers.push(sectionObserver);
  });
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

window.EupoupoLoadMore = {
  loadNextPage,
  getCurrentPage: () => getPaginationInputs().currentPage || 1,
  getTotalPages: () => getPaginationInputs().totalPages || 1,
  setRestoring: (value) => {
    isRestoringListing = Boolean(value);
    if (isRestoringListing) {
      activeObservers.forEach((obs) => obs.disconnect());
      activeObservers = [];
    } else {
      checkVisibility();
    }
  },
};

(function () {
  loadMore();
})();
